import { session1, session2, session3, session4, session5, session6, session7, session8, session9, session10 } from './sessions';
import { completion } from './completion.js';

export const networking = {
    id: "networking",
    title: "Networking Course",
    description: "Master computer networks from fundamentals to advanced concepts",
    color: "#27AE60",
    icon: "🌐",
    level: "Intermediate",
    duration: "9 hours",
    students: "1,580",
    sessions: [
        session1,
        session2,
        session3,
        session4,
        session5,
        session6,
        session7,
        session8,
        session9,
        session10,
        completion
    ]
};
